"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
const StyledTruncate = _styledComponents.default.div.withConfig({
  displayName: "Truncate__StyledTruncate",
  componentId: "sc-dt0gd1-0"
})(["", ";"], ({
  maxWidth
}) => `
    min-width: 0;
    flex: 0 1 ${maxWidth === "none" ? "100%" : maxWidth};
    max-width: ${maxWidth};
  `);
const StyledTruncateContent = _styledComponents.default.div.withConfig({
  displayName: "Truncate__StyledTruncateContent",
  componentId: "sc-dt0gd1-1"
})(["&,.orbit-text,.orbit-heading{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}"]);
const Truncate = ({
  children,
  maxWidth = "100%",
  dataTest
}) => /*#__PURE__*/React.createElement(StyledTruncate, {
  maxWidth: maxWidth,
  "data-test": dataTest
}, /*#__PURE__*/React.createElement(StyledTruncateContent, null, children));
var _default = Truncate;
exports.default = _default;